import {
  GET_PRODUCTS,
  GET_PRODUCTS_SUCCESS,
  GET_PRODUCTS_FAIL,
  GET_PRODUCT,
  GET_PRODUCT_SUCCESS,
  GET_PRODUCT_FAIL,
  CREATE_PRODUCT,
  CREATE_PRODUCT_SUCCESS,
  CREATE_PRODUCT_FAIL,
  UPDATE_PRODUCT,
  UPDATE_PRODUCT_SUCCESS,
  UPDATE_PRODUCT_FAIL,
  DELETE_PRODUCT,
  DELETE_PRODUCT_SUCCESS,
  DELETE_PRODUCT_FAIL,
  ATTACH_PRODUCT_IMAGE,
  ATTACH_PRODUCT_IMAGE_SUCCESS,
  ATTACH_PRODUCT_IMAGE_FAIL,
  UPLOAD_PRODUCT_IMAGE,
  UPLOAD_PRODUCT_IMAGE_SUCCESS,
  UPLOAD_PRODUCT_IMAGE_FAIL,
  UPDATE_PRODUCT_INVENTORY,
  UPDATE_PRODUCT_INVENTORY_SUCCESS,
  UPDATE_PRODUCT_INVENTORY_FAIL,
  CLEAR_PRODUCT_ERROR,
  CLEAR_SELECTED_PRODUCT,
} from "./actionTypes"

// Get all products with pagination and filters
export const getProducts = (params, history) => ({
  type: GET_PRODUCTS,
  payload: { params, history },
})

// Get product by ID
export const getProduct = (productId, history) => ({
  type: GET_PRODUCT,
  payload: { productId, history },
})

// Create new product
export const createProduct = (product, history) => ({
  type: CREATE_PRODUCT,
  payload: { product, history },
})

// Update product
export const updateProduct = (productId, product, history) => ({
  type: UPDATE_PRODUCT,
  payload: { productId, product, history },
})

// Delete product
export const deleteProduct = (productId, history) => ({
  type: DELETE_PRODUCT,
  payload: { productId, history },
})

// Attach existing document as product image
export const attachProductImage = (productId, documentId, isPrimary, history) => ({
  type: ATTACH_PRODUCT_IMAGE,
  payload: { productId, documentId, isPrimary, history },
})

// Upload base64 image and link to product
export const uploadProductImage = (productId, imageData, history) => ({
  type: UPLOAD_PRODUCT_IMAGE,
  payload: { productId, imageData, history },
})

// Update product inventory by terminal
export const updateProductInventory = (productId, items, history) => ({
  type: UPDATE_PRODUCT_INVENTORY,
  payload: { productId, items, history },
})

// Clear product errors
export const clearProductError = () => ({
  type: CLEAR_PRODUCT_ERROR,
})

// Clear selected product
export const clearSelectedProduct = () => ({
  type: CLEAR_SELECTED_PRODUCT,
})